import { Component, ViewChild, OnInit } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { ProductViewComponent } from '../productView/productView.component';
import { SearchResult } from "../Model/Dto/searchResults";
import { TranslateService } from "@ngx-translate/core";
import { Product } from "../Model/Catalog/Product";
import { Mime } from "../Model/Catalog/Mime";
import { LoginService } from "../Services/login.service";

@Component({
    selector: "searchcomponent",
    templateUrl: "./search.component.html",
    standalone: false
})
export class SearchComponent implements OnInit {

  constructor(public modelService: ModelService, public translate: TranslateService, public loginService: LoginService) {
    this.modelService.systemService.currentNavigationTitle = this.translate.instant("Suche");

  }
  @ViewChild(ProductViewComponent, { static: true }) productView: ProductViewComponent;

  refresh() {        
  }

  ngOnInit() { }

  public searchText: string = "";
  public resultCatalog = "";
  public resultProduct = "";
  public loadingVisible: boolean = false;

  getMimeText(mime) {
    return mime;
  }

  startSearch(): void {
    this.results = [];

    if (this.searchText === "") {
      return;
    }

    this.loadingVisible = true;

    this.modelService.catalogService
      .searchProducts(
        this.searchText,
        this.modelService.loginService.currentUser.customerId,
        1,
        100
      )
      .subscribe((result) => {
        this.results = result;
        this.loadingVisible = false;

        for (const searchResult of this.results) {
          this.loadCatalogName(searchResult);
        }
      });
  }

  private loadCatalogName(searchResult: any): void {
    this.getCatalogName(searchResult)
      .then((catalogName) => {
        searchResult.catalogName = catalogName;
      })
      .catch(() => {
        searchResult.catalogName = "";
      });
  }

  public results: SearchResult[] = [];

  testSearch() {
    if (this.searchText.length >= 3 ) {
      this.startSearch();
    }
  }

  async getCatalogName(product: SearchResult): Promise<string> {
    var catalogMapping = product.catalogMappings?.find(x => !x.isVirtualCatalog);

    if (!catalogMapping?.catalogId)
      return "";

    return await this.modelService.catalogService.getCatalogName(catalogMapping.catalogId, this.loginService.currentCustomer.id);
  }

  getImageMimes(mimes: Mime[]): Mime[] {
    if (!mimes)
      return [];
      
    return mimes.filter(m => m.mimeType?.startsWith("image/") && m.normUri);
  }

  jumpToProduct(product: Product) {
    var catalogMapping = product.catalogMappings?.find(x => !x.isVirtualCatalog);

    if (!catalogMapping?.catalogId)
      return;

    var navigateString = "/catalog/" + this.loginService.currentCustomer.id + "/" + catalogMapping.catalogId + "/product/" + product.id;
    this.modelService.catalogService.selectedCatalogId = catalogMapping.catalogId;
    this.modelService.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.modelService.router.navigate([navigateString]));
  }
}
